
<template>
  <div class="columns">
    <!-- <ImageCarousel
      class="image-carousel"
      :images="carousel_images"
      :isMobile="isMobile"
      :aspect="cover_image.ratio"
      :key="title"
      @on-mount="carouselMounted = true"
    /> -->
    <transition name="fade">
      <div class="columns-inner">
        <h1 class="project-header text-title">{{title}}</h1>
        <h5 class="tags text-sub-caption">{{kind}} | {{date}}</h5>
        <div class="description-block">
          <p class="description text-description" v-html="description"></p>
          <a v-if="website_url" class="link text-sub-caption" :href="website_url" target="_blank">visit site</a>
        </div>
        <PairList :items="listItems" />
        <ImageGrid
          :images="gridImages || [cover_image]"
        />
        <div class="next-cta">
          <router-link :to="nextProjectSlug">
            <h4 class="next-header text-caps">Next Project</h4>
            <h4 class="next-title text-subtitle" v-html="parsedNextTitle"></h4>
          </router-link>
        </div>	
      </div>
    </transition>
  </div>
</template>
<script>
  import { slugFunctions, stringFunctions } from '../mixins'; 
  import ImageCarousel from '../components/ImageCarousel';
  import ImageGrid from '../components/ImageGrid';
  import PairList from '../components/PairList';

  export default {
    name: 'ProjectPage',
    props: {
      title:            String, 
      date:             Number, 
      description:      String, 
      cover_image:      Object, 
      carousel_images:  Array, 
      tags:             String, 
      type:             String, 
      kind:             String, 
      role:             String, 
      team:             String, 
      github_url:       String,
      website_url:      String, 
      nextProject:      Object,
    },
    data() {
      return {
        isMobile: window.innerWidth <= 768,
        carouselMounted: false, 
      }
    },
    components: {
      ImageCarousel, 
      ImageGrid,
      PairList, 
    },
    computed: {
      parsedDescription() {
        return this.parseMarkdown(this.description); 
      },
      nextProjectSlug() {
        return this.nextProject && this.nextProject.title && this.toSlug(this.nextProject.title); 
      },
      gridImages() {
        return this.carousel_images && this.carousel_images.length > 1 && this.carousel_images.slice(1); 
      },
      listItems() {
        return [
            {type: "Date",         value: this.date}, 
            {type: "Project Role", value: this.role},
            {type: "Team",         value: this.team}
          ]
      },
      parsedNextTitle() {
        const nextWordCount = this.nextProject.title.split(' ').length;
        const splitWords    = this.nextProject.title.split(' ');
        if(nextWordCount > 3 && this.nextProject.title.length > 20) {
          return (
            splitWords.slice(0, Math.round(nextWordCount / 2)).join(' ') + 
            '<br>' +
            splitWords.slice(Math.round(nextWordCount / 2)).join(' ')
          );
        } else {
          return this.nextProject.title; 
        }
      }
    },
    methods: {
      getIsMobile() {
        this.isMobile = window.innerWidth <= 768; 
      }
    },
    created() {
      window.addEventListener('resize', this.getIsMobile, {passive: true})
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getIsMobile); 
    },
    mixins: [slugFunctions, stringFunctions]
  }
</script>

<style lang="sass" scoped>
  @import '../assets/partials/_vars'

  .columns
    .project-header
      font-weight: 400
      margin-top: 10rem
      margin-bottom: 0.5rem

    .tags
      text-transform: capitalize
      margin-bottom: 8rem
      letter-spacing: 0.01em

    .image-grid-container
      width: 110.5%
      margin: 0 -5.25%

    .description-block
      display: flex
      flex-direction: column
      justify-content: space-between
      margin-bottom: 2rem
      .description
        width: 100%
        margin-bottom: 2rem
        a
          color: $tertiary-color !important
          font-style: italic
          display: none
        em
          font-style: italic

      .link
        display: block
        text-align: center
        border: 2px solid $primary-color
        border-radius: 18px
        padding: 1rem
        font-weight: 300
        transition: border 150ms ease, color 150ms ease

    $circle-radius: 25px

    .next-cta
      +flex-center
      width: 100%
      cursor: pointer
      position: relative
      text-align: center
      margin: 0 auto
      margin-bottom: 0
      padding-top: 3rem
      padding-bottom: $circle-radius 
      overflow: hidden

      .next-header
        margin: 0
        opacity: 0.5 
        font-weight: 200
        position: relative
        margin-bottom: 4px

      .next-title 
        transition: color 333ms cubic-bezier(.99,.0,.33,1)

      &:after
        content: ""
        margin: auto
        +circle($circle-radius)
        +abs-center-bottom
        transform: translate(-50%, -50%)
        z-index: -1
        border: 3px solid rgb(52 174 21)
        background: rgb(52 174 21)
        box-shadow: 0px 0px 5px 5px rgb(52 174 21)

      a:focus, a:hover 
        .next-title
          color: $tertiary-color


// /* For Desktop */
+after-bg-mobile
  .columns
    margin-bottom: 2rem

    .project-header
      margin-top: 0rem
      text-align: left
      width: 60%

    .tags
      margin-top: 0.1rem
      margin-bottom: 5rem
      text-align: left
      .tag
        display: inline

    .image-grid-container
      width: 10/10 * 100vw
      margin: 5rem 0

    .pair-list-container
      width: 7/10 * 100vw

    .description-block
      display: flex
      flex-direction: row
      justify-content: space-between
      align-items: flex-start
      margin-bottom: 5rem

      .description
        width: 7/10 * 100vw


      .link
        &:hover
          color: $secondary-color
          background: $tertiary-color 
          border-color: $tertiary-color 
          cursor: pointer     
    
    .carousel-container
      margin: 0
      width: 100%
      margin-bottom: 5rem
    
    .next-cta
      +flex-column
      align-items: flex-end
      padding: 0
      margin: auto
      margin-top: 15rem
      margin-bottom: 8rem
      text-align: right
      overflow: visible
      width: 6 / 28 * 100vw
      margin-left: 14 / 28 * 100vw

      &:after
        position: unset
        margin-left: auto
        margin: 0
        transform: none
        margin-top: 24px

      .next-title
        br
          display: block
      
  
+after-sm-desktop
  .columns
    .description-block
      .description
        width: 5/10 * 100vw

    .details
      width: 7/10 * 100vw

    .image-grid-container
      width: 100%
      margin: 5rem 0

</style>




